const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validEmail = (email: string) => emailRegex.test(email);

export const isEmptyEmail = (email: string) => email.trim().length === 0;
